import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

type Params = {
  masterUuid: string
  jobUuid: string
}

export const useMutationExecuteMasterBatchJob = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ masterUuid, jobUuid }: Params) => {
      return await baseClient
        .getApi(MasterApi)
        .executeMasterBatchJob({ masterUuid, jobUuid })
        .catch(handleHTTPError)
    },
    onSuccess: (_data, { masterUuid }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.masterLatestBatchJobStatus(masterUuid),
      })
    },
  })
}
